import { gql } from "@apollo/client";

export const GET_DASHBOARD_STOCK_INFO = gql`
  query GetDashboardStockInfo($to: Date, $from: Date) {
    getDashboardStockInfo(to: $to, from: $from) {
      totalStockInQty
      totalStockInAmount
      totalStockOutQty
      totalStockOutAmount
      totalRemainInStockQty
      totalRemainInStockAmount
      totalSupplierQty
    }
  }
`;

export const GET_DASHBOARD_TOTAL_ITEM = gql`
  query GetDashboardTotalItem {
    getDashboardTotalItem {
      _id
      title
      total
    }
  }
`;

export const GET_STUDENT_PAID_AND_NOT_YET_GET_MATERIALS = gql`
  query GetStudentPaidAndNotYetGetMaterials(
    $academicYearId: String
    $fromDate: String
    $toDate: String
  ) {
    getStudentPaidAndNotYetGetMaterials(
      academicYearId: $academicYearId
      fromDate: $fromDate
      toDate: $toDate
    ) {
      studentId
      firstName
      lastName
      englishName
      incomeHead
      invoiceNo
      classGrade
      profileImg
    }
  }
`;
